import { ImageWrapper } from '../../common/wrappers/ImageWrapper';
import React, { useState } from 'react';

type Props = {
    markerPosition?: number;
    onClick: () => void;
    image: any;
};

export default function MMap({ markerPosition, image }: Props) {
    const [dragging, setDragging] = useState(false);

    if (!markerPosition) {
        return <React.Fragment />;
    }

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        if (!dragging) {
            // onClick && onClick();
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!dragging) {
            // onClick && onClick();
        }
        setDragging(false);
    };

    return (
        <React.Fragment>
            <div className="m-full-image m-map">
                <div
                    className={`marker marker-pos-${markerPosition}`}
                    onTouchStart={() => {
                        setDragging(false);
                    }}
                    onTouchMove={() => {
                        setDragging(true);
                    }}
                    onTouchEnd={handleTouch}
                    onClick={handleClick}
                />
                <ImageWrapper src={image} alt="map" shouldScroll={true} allowLightbox={false} />
            </div>
        </React.Fragment>
    );
}
